// extracted by mini-css-extract-plugin
module.exports = {"H4":"styles_H4__2fcEx","input":"styles_input__2C39f","docsDefault":"styles_docsDefault__314l0","docsOk":"styles_docsOk__2zC6Q","toDocs":"styles_toDocs__39COi"};